module.exports = __webpack_public_path__ + "media/images/design/images/dantai_search/btn_dantai_new-a22325f0a7e1dab09b9fbf0153e059ad.jpg";